if (!customElements.get("cart-free-gifts-310")) {
    customElements.define(
      "cart-free-gifts-310",
      class CartFreeGifts310 extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
        }

        async init() {
          const freeGiftsSettings = document.querySelector('[data-free-gifts-settings]');
          this.freeGiftsSettingsJSON = JSON.parse(freeGiftsSettings?.textContent);

          if(!this.freeGiftsSettingsJSON) return;
          

          this.product_1 = this.freeGiftsSettingsJSON.product_1;
          this.product_2 = this.freeGiftsSettingsJSON.product_2;
          this.product_3 = this.freeGiftsSettingsJSON.product_3;
          this.product_4 = this.freeGiftsSettingsJSON.product_4;


          const addFreeGift = (freeProductObj, cartData) => {
            if(!freeProductObj) return;
            const { thresholdProduct, freeGiftProduct } = freeProductObj;
          }

          const getCartJSON = async () => {
            return fetch('/cart.js')
              .then(response => response.json())
              .then(data => data)
              .catch(error => console.error('Error fetching cart:', error));
          }

          const onCartUpdate = async(e) => {
            let cartData = e.cartData;
            let addFormData = {
              'items': []
            };
            let updateFormData = {};

            if(e.source === 'product-form'){
              cartData = await getCartJSON();
            }

            const totalCartPrice = cartData.total_price;

            // prepare data to add and for remove

            for (const configProduct of this.freeGiftsSettingsJSON) {
              // const configProduct = this.freeGiftsSettingsJSON[0];
              const configProductInCart = cartData.items.find(item => item.variant_id == configProduct.free_gift_product.variant_id);
              
              if(totalCartPrice >= configProduct.threshold_product.price && !configProductInCart) {
                const parsedVariantId = parseInt(configProduct.free_gift_product.variant_id);
                addFormData.items.push({
                  'id': parsedVariantId,
                  'quantity': 1,
                  'properties': {
                    '_cart_free_gift': 'true'
                  }
                });
              } else if(totalCartPrice < configProduct.threshold_product.price && configProductInCart) {
                const parsedVariantId = configProduct?.free_gift_product?.variant_id;
                updateFormData[parsedVariantId] =  0;
              } else if(totalCartPrice > configProduct.threshold_product.price && configProductInCart && configProductInCart.quantity > 1) {
                const parsedVariantId = configProduct?.free_gift_product?.variant_id;
                updateFormData[parsedVariantId] =  1;
              } 
            }

            // configured items as free gifts
            const addedFreeGits = [...document.querySelectorAll('[data-free-gift]')]?.map(item => parseInt(item.dataset.variantId));

            // items in cart that are configured as free gifts
            const freeGiftItems = cartData.items.filter(item => addedFreeGits.includes(item.variant_id));

            
            for (const freeGiftItem of freeGiftItems) {
              let isExistInConfig = false;
              for (const configProduct of this.freeGiftsSettingsJSON) {
                if(freeGiftItem.variant_id == configProduct.free_gift_product.variant_id) {
                  isExistInConfig = true;
                  break;
                }
              }

              if(!isExistInConfig) {
                updateFormData[freeGiftItem.variant_id] = 0;
              }
            }

            const addCartItems = async () => {
              if (addFormData.items.length < 1) return;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(addFormData)
              }).then(response => response.json())
              .then(data => data)
              .catch(error => console.error('Error adding to cart:', error));
            }

            const updateCartItems = async () => {
              if (Object.keys(updateFormData).length < 1) return;

              return fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({"updates": updateFormData})
              }).then(response => response.json())
              .then(data => data)
              .catch(error => console.error('Error removing from cart:', error));
            }

            const refreshCart = async() => {


              const cartDrawer = document.querySelector('cart-drawer');
              await cartDrawer.refreshCartDrawer();

            }
            
            // block checkout button while updating free gifts
            const checkoutButton = document.querySelector('cart-drawer button[name="checkout"]');
            if(checkoutButton) {
              checkoutButton.setAttribute('disabled', true);
              checkoutButton.textContent = 'Updating free gifts...';
            }

            await addCartItems();
            await updateCartItems();

            setTimeout(async () => {
              await refreshCart();
            }, 100);
          }

          subscribe(PUB_SUB_EVENTS.cartUpdate, async(e) => {
            onCartUpdate(e);
          });

          await onCartUpdate({
            source: 'product-form'
          });

        }
      },
    );
  }
  

  // TODO: sprawdzic jak to działa na kilku free giftach
  // sprawdzić jak to działa z innymi produktami w koszyku
  // dodać kolejne free gifty z innymi thresholdami
  // schować dodawanie/usuwanie ilości free giftów

  // document.addEventListener('DOMContentLoaded', () => {
  //   subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
  //     console.log(e);
  //   });
  // });